import React from "react";
import { useTranslation } from "react-i18next";
import { Baner } from "agronomist-ui-components";
import "./Banners.scss";

/**
 * Square banners
 */

/**
 * Fullwidth banners
 */

export const KredytomatBaner = props => {
  const { t } = useTranslation(["widgets"]);
  return (
    <Baner
      className={`${props.className} square-baner-on-mobile ${
        props.darkText === true ? "text-black" : ""
      }`}
      type="article"
      coverUrl={
        window.innerWidth < 767
          ? require("../../../assets/img/kredytomat-banner-small.jpg")
          : require("../../../assets/img/kredytomat-banner.png")
      }
      title={t("widgets:kredytomat.title")}
      description={t("widgets:kredytomat.subtitle").replace(" i ", "\ni ")}
      label={t("widgets:kredytomat.btn")}
      url="/kredytomat"
    />
  );
};

export const AgroemisjaBaner = props => {
  const { t } = useTranslation(["widgets"]);
  return (
    <Baner
      className={`${props.className} square-baner-on-mobile ${
        props.darkText === true ? "text-white" : ""
      }`}
      type="article"
      coverUrl={
        window.innerWidth < 767
          ? require("../../../assets/img/baner_360x360.png")
          : require("../../../assets/img/baner_ 118x3022.png")
      }
      title={t("widgets:agroemisja.title")}
      description={t("widgets:agroemisja.subtitle").replace(" i ", "\ni ")}
      label={t("widgets:agroemisja.btn")}
      url="/agroemisja"
    />
  );
};

export const RegisterBaner = ({ i18n }) => {
  const { t } = useTranslation(["globals", "landingPage"]);
  return (
    <Baner
      type="big"
      coverUrl={require("../../../assets/img/brzmiinteresujacao.jpg")}
      label={t("globals:buttons.register")}
      title={t("landingPage:bottom.claim")}
      url={i18n.language === "pl" ? "uzytkownik/rejestracja" : "user/register"}
    />
  );
};
